import { nodeChain, Text, textChain } from '@revolut-internal/ui-kit'

import {
  CountMetric,
  CountWithPercentageMetric,
  QueueingSystem,
} from 'modules/Monitoring/types'
import { formatNumber } from 'modules/Monitoring/utils/formatNumber'
import { pluralize } from 'modules/Monitoring/utils/pluralize'

import { QueueHealthDetailFormattedData } from '../types'

const DANTE_OTHER_AREA_NAME = 'Other'

export const formatMetric = (metric: CountWithPercentageMetric) =>
  nodeChain(
    formatNumber(metric.value),
    <Text color={metric.slaBreach ? 'warning' : 'grey-tone-50'}>
      {formatNumber(metric.percentageOfTotal)}%
    </Text>,
  )

export const formatMetricTooltip = (
  metric: CountWithPercentageMetric,
  entity: string,
) => (
  <Text>
    {formatNumber(metric.value)} {pluralize(entity, metric.value, true)},{' '}
    {formatNumber(metric.percentageOfTotal)}% of total scheduled
  </Text>
)

export const formatDanteLabel = (data: QueueHealthDetailFormattedData) => {
  const area =
    data.queueingSystem === QueueingSystem.Native ? DANTE_OTHER_AREA_NAME : data.areaName

  return textChain(data.departmentName, area, data.name)
}

export const toCountWithPercentage = (
  metric?: CountMetric,
): CountWithPercentageMetric | null =>
  metric
    ? {
        value: metric?.value ?? 0,
        percentageOfTotal: 0,
        slaBreach: metric?.slaBreach ?? false,
      }
    : null
